export const baseImageUrl =
  process.env.REACT_APP_IMAGE_CDN_URL ||
  "https://wishaurcategoryimage.s3.ap-south-1.amazonaws.com/";

export function getImageUrl(imagePath) {
  if (!imagePath) return null;

  const value = String(imagePath).trim();
  if (!value) return null;

  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }

  const normalizedBase = baseImageUrl.endsWith("/") ? baseImageUrl : `${baseImageUrl}/`;
  return `${normalizedBase}${value.replace(/^\//, "")}`;
}
